import { useMutation, useQuery } from "@apollo/client";
import ReactTable from "react-table";
import { GET_CSO_LIST } from "../queries";
import { Input, Spinner, UncontrolledTooltip } from "reactstrap";
import { Fragment, useState, useMemo, useEffect } from "react";
import Loader from "react-loaders";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
} from "reactstrap";
import styles from "./index.module.scss";
import {
  DELETE_CSO_WISH,
  DELETE_SUPPORTER_STATUS,
  SUPPORTER_FIRST_MESSAGE,
} from "../mutations";
import { parseArray } from "../helpers";
import { Link } from "react-router-dom";
import { Multiselect } from "react-widgets";
import { GET_ALL_COLLABORATION_NEEDS, GET_MESSAGE_LIST } from "../queries";
import logo from "../../../../assets/utils/images/animetion_logo.gif";
import {
  idealStartingTimeOptions,
  collaborationScaleOptions,
} from "../MessageList/Wishes";
import DissolveBadge from "../../../../components/DissolveBadge";
import { CHECK_USER_STATUS } from "../../../../queries";
import { useUserEmail } from "../../../../Layout/AppMain/LoginStatusContext";

export const statusChipStyle = {
  面談予定: {
    backgroundColor: "#FFF09F",
    border: "1px solid #E4A400",
    color: "#E4A400",
  },
  問合せ中: {
    backgroundColor: "#FFD5D4",
    color: "#FF0000",
    border: "1px solid #FF0000",
  },
  面談終了: {
    backgroundColor: "#D6D6D6",
    color: "#495057",
    border: "1px solid #495057",
  },
  面談依頼中: {
    backgroundColor: "#BBFFAA6B",
    color: "#1D9200",
    border: "1px solid #1D9200",
  },
  連携中: {
    backgroundColor: "#75EBFF2B",
    color: "#44CAE1",
    border: "1px solid #44CAE1",
  },
  新着: {
    backgroundColor: "#D5D4FF",
    color: "#0500FF",
    border: "1px solid #0500FF",
  },
  default: {
    backgroundColor: "#FFF09F",
    color: "#E4A400",
    border: "1px solid #E4A400",
  },
};

const tabs = [
  {
    key: "csoWish",
    title: "登録済みCSO",
  },
  {
    key: "supporterStatus",
    title: "メッセージ一覧",
  },
];

const CSOPartnershipTable = (props) => {
  const { activeKey } = props;
  const {
    loading,
    data: rawData,
    refetch: refetchCsoList,
  } = useQuery(GET_CSO_LIST, {
    errorPolicy: "ignore",
  });
  const { loadingMessage, data: rawMessageData } = useQuery(GET_MESSAGE_LIST);
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [checkedOrgs, setCheckedOrgs] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [longestSDGs, setLongestSDGs] = useState(0);
  const [activeTab, setActiveTab] = useState("csoWish");
  const [collabModalOpen, setCollabModalOpen] = useState({
    open: false,
    item: null,
  });
  const [csoID, setCsoId] = useState();
  const [collaborationNeed, setCollaborationNeed] = useState([]);
  const [collaborationNeedName, setCollaborationNeedName] = useState([]);
  const [idealStartingTime, setIdealStartingTime] = useState("未定");
  const [collaborationScale, setCollaborationScale] = useState("未定");
  const [message, setMessage] = useState("");
  const [supporter, setSupporter] = useState();
  const [reviewDataModal, setReviewDataModal] = useState(false);
  const [recommendationModal, setRecommendationModal] = useState(false);

  useEffect(() => {
    localStorage.setItem("tabActive", activeKey);
  }, [activeKey]);

  const data = useMemo(() => {
    if (!rawData) return [];
    if (activeTab === "csoWish") {
      return rawData?.myCsoWishes?.edges?.map((edge) => {
        const length = parseArray(edge.node.cso.sdgsImages).filter(
          (v) => v !== ""
        ).length;
        if (length > longestSDGs) {
          setLongestSDGs(length);
        }

        return {
          readableSupporterStatus: "候補",
          isDone: false,
          ...edge.node,
        };
      });
    } else {
      return rawData?.myCollaborationStatusesAsSupporter?.edges?.map((edge) => {
        const length = parseArray(edge.node.cso.sdgsImages).filter(
          (v) => v !== ""
        ).length;
        if (length > longestSDGs) {
          setLongestSDGs(length);
        }
        return edge.node;
      });
    }
  }, [rawData, longestSDGs, activeTab]);

  const tableLength = useMemo(() => {
    return data.length;
  }, [data]);

  const toggle = () => setDeleteModalOpen(!deleteModalOpen);

  const [
    deleteCsoWish,
    { data: deletedCsoWish, loading: loadingDeleteCsoWish },
  ] = useMutation(DELETE_CSO_WISH);
  const [
    deleteCollaborationStatus,
    {
      data: deletedCollaborationStatus,
      loading: loadingDeleteCollaborationStatus,
    },
  ] = useMutation(DELETE_SUPPORTER_STATUS);

  const handleCheckRow = (id) => {
    if (!id) return;
    if (checkedOrgs.includes(id))
      setCheckedOrgs(checkedOrgs.filter((orgId) => orgId !== id));
    else setCheckedOrgs([...checkedOrgs, id]);
  };

  const handleDeleteCsoWish = () => {
    if (selectedOrg?.__typename === "CollaborationStatusNode") {
      deleteCollaborationStatus({
        variables: {
          supporterStatusId: selectedOrg.id,
        },
        onCompleted: () => {
          refetchCsoList();
        },
      });
    } else {
      deleteCsoWish({
        variables: {
          csoWishId: selectedOrg.id,
        },
        onCompleted: () => {
          refetchCsoList();
        },
      });
    }
    setSelectedOrg(null);
    setDeleteModalOpen(false);
  };

  const { data: checkUserStatus } = useQuery(CHECK_USER_STATUS, {
    variables: {
      email: useUserEmail(),
    },
  });

  const canEdit =
    checkUserStatus?.allUsers?.edges[0]?.node?.supporterRole === "can_edit" ||
    checkUserStatus?.allUsers?.edges[0]?.node?.supporterRole === "CAN_EDIT";

  const partnershipTableColumns = [
    {
      Header: "選択問合せ",
      accessor: "checkbox",
      width: 90,
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "center", width: "70px" }}>
            <Input
              onChange={() => {
                handleCheckRow(row._original.id);
              }}
              checked={[...checkedOrgs].includes(row._original.id)}
              style={{ position: "relative", left: 10 }}
              type="checkbox"
            />
          </div>
        );
      },
    },
    {
      Header: "ステータス",
      accessor: "readableSupporterStatus",
      width: 110,
      Cell: ({ row }) => {
        const status = row._original.readableSupporterStatus;
        const hasNewMessage = row?._original?.supporterHasNewMessage;

        if (!status) return <></>;
        return (
          <div
            style={{
              ...(statusChipStyle[status] || statusChipStyle["default"]),
              fontSize: "11px",
              padding: "3px 11px",
              borderRadius: "18px",
              whiteSpace: "nowrap",
              margin: "auto",
              position: "relative",
            }}
          >
            {status}
            {hasNewMessage && (
              <div
                style={{
                  position: "absolute",
                  top: "-3px",
                  right: "0",
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: "#FF0000",
                }}
              />
            )}
          </div>
        );
      },
    },
    {
      Header: "組織名",
      accessor: "cso.name",
      minWidth: 325,
      Cell: ({ row }) => {
        const cso = row._original.cso;
        return (
          <>
            {cso?.homepage ? (
              <>
                {cso?.isPublic ? (
                  <Link
                    to={`/dashboards/plofile-organization/${cso.pk}`}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    {cso.name}
                    {cso.isDissolve && <DissolveBadge />}
                  </Link>
                ) : (
                  <div
                    role="button"
                    style={{
                      color: "#545cd8",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                    onClick={() => {
                      alert("本組織の情報は非公開となっています");
                    }}
                  >
                    {cso.name}
                    {cso.isDissolve && <DissolveBadge />}
                  </div>
                )}
              </>
            ) : (
              <span>{cso.name}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "団体規模",
      accessor: "cso.revenueCategory.scale",
      width: 200,
      Cell: ({ row }) => {
        return row._original.cso.revenueCategory.scale;
      },
    },
    {
      Header: "HP",
      accessor: "homepage",
      width: 75,
      Cell: ({ row }) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "75px",
            }}
          >
            <a
              href={row._original.cso.homepage}
              target="_blank"
              rel="noreferrer"
            >
              <i
                className="pe-7s-link"
                style={{ fontSize: "20px", color: "#000" }}
              ></i>
            </a>
          </div>
        );
      },
    },
    {
      Header: "メッセージ",
      accessor: "message",
      width: 100,
      Cell: ({ row }) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "125px",
            }}
          >
            {activeTab === "supporterStatus" ? (
              <Link
                to={
                  activeTab === "supporterStatus"
                    ? `/dashboards/organization-partnership/message/${row._original.id}`
                    : ``
                }
                target="_blank"
                rel="noreferrer"
              >
                <i
                  className="pe-7s-mail"
                  style={{ fontSize: "20px", color: "#000" }}
                ></i>
              </Link>
            ) : (
              <>
                {canEdit && (
                  <div
                    role="button"
                    onClick={() => {
                      toggleCollabModal(row._original);
                    }}
                  >
                    <i
                      className="pe-7s-mail"
                      style={{ fontSize: "20px", color: "#000" }}
                    ></i>
                  </div>
                )}
              </>
            )}
          </div>
        );
      },
    },
    {
      Header: "ダウンロード",
      accessor: "download",
      width: 119,
      Cell: ({ row }) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "125px",
            }}
          >
            <a
              href={`https://datestore.socialmap.jp/orgapi/createPDF?id=${row?._original?.cso?.id}`}
              target="_blank"
              rel="noreferrer"
            >
              <i
                className="pe-7s-file"
                style={{ fontSize: "20px", color: "#000" }}
              ></i>
            </a>
          </div>
        );
      },
    },
    {
      Header: () => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              justifyContent: "center",
            }}
            className="hatena_box"
          >
            <span>情報度</span>
            <span
              style={{
                width: "20px",
                height: "20px",
                fontSize: "13px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                border: "1px solid #adaeaf",
                color: "#adaeaf",
              }}
              id="quality"
            >
              ?
            </span>
            <UncontrolledTooltip target="quality" placement="top">
              <div
                style={{
                  textAlign: "left",
                }}
              >
                <p>
                  星の数はSocial
                  map上に掲載されている組織情報の充実度によって自動で変わります。
                </p>
                <p>星1：「組織概要」の記載</p>
                <p>星2：「活動国」「財務データ」の記載</p>
                <p>星3：「ミッションと連携方針」の記載</p>
              </div>
            </UncontrolledTooltip>
          </div>
        );
      },
      accessor: "cso.quality",
      minWidth: 119,
      Cell: ({ row }) => {
        const public_info_quality =
          row._original.cso.publicInformationScore ?? 0;
        const max_quality = 3;

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "2px",
              width: "100px",
            }}
          >
            {new Array(public_info_quality).fill(0).map((item, idx) => {
              return (
                <div key={idx}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.04893 3.92731C9.34828 3.006 10.6517 3.006 10.951 3.92731L12.0206 7.21911C12.1545 7.63113 12.5384 7.91009 12.9717 7.91009H16.4329C17.4016 7.91009 17.8044 9.14971 17.0207 9.71911L14.2205 11.7536C13.87 12.0082 13.7233 12.4596 13.8572 12.8716L14.9268 16.1634C15.2261 17.0847 14.1717 17.8508 13.3879 17.2814L10.5878 15.247C10.2373 14.9923 9.76269 14.9923 9.4122 15.247L6.61203 17.2814C5.82832 17.8508 4.77384 17.0847 5.07319 16.1634L6.14276 12.8716C6.27663 12.4596 6.12997 12.0082 5.77949 11.7536L2.97932 9.71911C2.1956 9.14971 2.59838 7.91009 3.5671 7.91009H7.0283C7.46153 7.91009 7.84548 7.63113 7.97936 7.21911L9.04893 3.92731Z"
                      fill="#646262"
                    />
                  </svg>
                </div>
              );
            })}
            {new Array(max_quality - public_info_quality)
              .fill(0)
              .map((item, idx) => {
                return (
                  <div key={idx}>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_270_3987)">
                        <path
                          d="M9.04896 2.92664C9.34833 2.00537 10.6517 2.00538 10.951 2.92664L12.0208 6.21864C12.1547 6.63063 12.5386 6.90957 12.9718 6.90958L16.4333 6.90971C17.402 6.90975 17.8047 8.1493 17.0211 8.71871L14.2208 10.7534C13.8703 11.008 13.7237 11.4594 13.8575 11.8714L14.927 15.1635C15.2263 16.0847 14.1719 16.8508 13.3882 16.2815L10.5878 14.247C10.2373 13.9924 9.76272 13.9924 9.41225 14.247L6.61179 16.2815C5.82809 16.8508 4.77367 16.0847 5.07297 15.1635L6.14249 11.8714C6.27634 11.4594 6.1297 11.008 5.77924 10.7534L2.97894 8.71871C2.19528 8.1493 2.59804 6.90975 3.56672 6.90971L7.02818 6.90958C7.46137 6.90957 7.8453 6.63063 7.97918 6.21864L9.04896 2.92664Z"
                          stroke="#646262"
                          stroke-width="2"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_270_3987">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                );
              })}
          </div>
        );
      },
    },
    // {
    //   Header: () => {
    //     return (
    //       <div
    //         style={{
    //           display: "flex",
    //           alignItems: "center",
    //           gap: "8px",
    //           justifyContent: "center",
    //         }}
    //         className="hatena_box"
    //       >
    //         <span>信頼度</span>
    //         <span
    //           style={{
    //             width: "20px",
    //             height: "20px",
    //             fontSize: "13px",
    //             display: "flex",
    //             alignItems: "center",
    //             justifyContent: "center",
    //             borderRadius: "50%",
    //             border: "1px solid #adaeaf",
    //             color: "#adaeaf",
    //           }}
    //           id="reliability"
    //         >
    //           ?
    //         </span>
    //         <UncontrolledTooltip target="reliability" placement="top">
    //           <div
    //             style={{
    //               textAlign: "left",
    //             }}
    //           >
    //             <p>
    //               月の数はSocial
    //               map上に掲載されている組織情報の充実度によって自動で変わります。
    //             </p>
    //             <p>月1：「ネットワーク組織」の加盟</p>
    //             <p>月2：「第三者認証」の実施</p>
    //             <p>月3： 現在基準設定中</p>
    //           </div>
    //         </UncontrolledTooltip>
    //       </div>
    //     );
    //   },
    //   accessor: "cso.reliability",
    //   minWidth: 119,
    //   Cell: ({ row }) => {
    //     // RELIABILITY COLUMN
    //     const realiability_score = row?._original?.cso?.reliabilityScore;
    //     const max_reliability = 3;
    //     return (
    //       <div
    //         style={{
    //           display: "flex",
    //           alignItems: "center",
    //           justifyContent: "center",
    //           gap: "2px",
    //           width: "100px",
    //         }}
    //       >
    //         {new Array(realiability_score).fill(0).map((item, idx) => {
    //           return (
    //             <div key={idx}>
    //               <svg
    //                 width="20"
    //                 height="20"
    //                 viewBox="0 0 20 20"
    //                 fill="none"
    //                 xmlns="http://www.w3.org/2000/svg"
    //               >
    //                 <path
    //                   d="M17.2929 13.2933C16.2886 13.7474 15.1738 14.0003 14 14.0003C9.58172 14.0003 6 10.4185 6 6.00026C6 4.82629 6.25287 3.71138 6.70712 2.70703C3.93137 3.96228 2 6.75563 2 10.0001C2 14.4183 5.58172 18.0001 10 18.0001C13.2443 18.0001 16.0376 16.0689 17.2929 13.2933Z"
    //                   fill="#646262"
    //                 />
    //               </svg>
    //             </div>
    //           );
    //         })}
    //         {new Array(max_reliability - realiability_score)
    //           .fill(0)
    //           .map((item, idx) => {
    //             return (
    //               <div key={idx}>
    //                 <svg
    //                   width="20"
    //                   height="20"
    //                   viewBox="0 0 20 20"
    //                   fill="none"
    //                   xmlns="http://www.w3.org/2000/svg"
    //                 >
    //                   <path
    //                     d="M16.9618 12.796C16.098 13.1432 15.1546 13.3342 14.1667 13.3342C10.0245 13.3342 6.66667 9.97636 6.66667 5.83422C6.66667 4.84624 6.8577 3.90288 7.20484 3.03906C4.44707 4.14733 2.5 6.84673 2.5 10.0009C2.5 14.143 5.85786 17.5009 10 17.5009C13.1542 17.5009 15.8536 15.5538 16.9618 12.796Z"
    //                     stroke="#646262"
    //                     stroke-width="2"
    //                     stroke-linecap="round"
    //                     stroke-linejoin="round"
    //                   />
    //                 </svg>
    //               </div>
    //             );
    //           })}
    //       </div>
    //     );
    //   },
    // },
    {
      Header: "SDGs",
      accessor: "cso.sdgsImages",
      minWidth: longestSDGs * 25 + 20,
      Cell: ({ row }) => {
        const sgdsLogos = parseArray(row._original.cso.sdgsImages).filter(
          (item) => item !== ""
        );
        return (
          <div
            className="d-flex w-100"
            style={{
              maxWidth: "330px",
              flexWrap: "wrap",
            }}
          >
            {sgdsLogos.map((logo) => {
              return (
                <div key={logo} className="mr-1 mb-1">
                  <img
                    src={logo}
                    alt="sdg"
                    style={{ width: "30px", height: "30px" }}
                  />
                </div>
              );
            })}
          </div>
        );
      },
    },
    {
      Header: "ステークホルダー",
      accessor: "cso.csocollaborationneeds.stakeholders",
      width: 200,
      Cell: ({ row }) => {
        return (
          row?._original?.cso?.csocollaborationneeds?.stakeholders?.edges
            ?.map((edge) => edge?.node?.name)
            .join("/ ") ?? ""
        );
      },
    },
    {
      Header: "",
      width: 45,
      Cell: ({ row }) => {
        return (
          <>
            {canEdit && (
              <button
                type="button"
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  width: "",
                  fontSize: "12px",
                }}
                onClick={() => {
                  setSelectedOrg(row._original);
                  setDeleteModalOpen(true);
                }}
              >
                &#x2715;
              </button>
            )}
          </>
        );
      },
    },
  ];

  const { data: dataCollaborationNeeds } = useQuery(
    GET_ALL_COLLABORATION_NEEDS
  );

  let doropdownData = dataCollaborationNeeds?.allCollaborationNeeds.edges.map(
    (edge) => ({
      id: edge.node.intId,
      color: edge.node.title,
    })
  );

  const toggleCollabModal = (data) => {
    setCsoId(data.cso.id);
    setCollabModalOpen({ open: !collabModalOpen.open, item: data });
  };

  const toggleReviewDataModal = () => setReviewDataModal(!reviewDataModal);

  const [createCollaboration, { loading: loadingCreateCollaboration }] =
    useMutation(SUPPORTER_FIRST_MESSAGE, {
      onCompleted: () => {
        refetchCsoList();
      },
    });

  const handleSubmit = async () => {
    await createCollaboration({
      variables: {
        supporter: supporter,
        message: message,
        idealStartingTime: idealStartingTime,
        collaborationScale: collaborationScale,
        cso: csoID,
        collaborationNeeds: collaborationNeed,
      },
    })
      .then((response) => {
        setReviewDataModal(false);
        setCollabModalOpen({ open: false, item: null });
        setRecommendationModal(true);
      })
      .catch((error) => {
        setReviewDataModal(false);
        setRecommendationModal(false);
        alert(error.message);
        console.log(error);
      });
  };

  useEffect(() => {
    if (collabModalOpen.open) {
      setCollaborationNeed([]);
      setCollaborationNeedName([]);
      setIdealStartingTime("未定");
      setCollaborationScale("未定");
      setMessage("");
    }
  }, [collabModalOpen.open]);

  useEffect(() => {
    if (rawMessageData?.allSupporters?.edges[0].node.id) {
      setSupporter(rawMessageData?.allSupporters?.edges[0].node.id);
    }
  }, [rawMessageData]);

  return (
    <Fragment>
      <div
        style={{
          marginBottom: "20px",
          marginTop: "20px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        {tabs.map((tab) => {
          return (
            <button
              onClick={() => {
                setActiveTab(tab.key);
              }}
              style={{
                backgroundColor:
                  activeTab === tab.key ? "#56ccf2" : "rgb(189, 189, 189)",
                color: "#fff",
                border: "none",
                padding: "10px 20px",
                borderRadius: "5px",
              }}
            >
              {tab.title}
            </button>
          );
        })}
      </div>
      <ReactTable
        loading={loading}
        loadingText={
          <div>
            <h6 className="mt-3">
              <img
                style={{ width: "80px", marginTop: "-150px" }}
                src={logo}
              ></img>
            </h6>
          </div>
        }
        defaultPageSize={10}
        className="-striped -highlight"
        previousText="前へ"
        nextText="次へ"
        pageText=""
        ofText="of"
        rowsText=""
        style={{ cursor: "pointer" }}
        data={data?.filter((item) => {
          return item?.isDone === false;
        })}
        columns={
          activeTab === "csoWish"
            ? partnershipTableColumns
            : partnershipTableColumns.slice(
                1,
                partnershipTableColumns.length - 1
              )
        }
      />
      <div className={styles["collab-modal-container"]}>
        <Modal
          isOpen={collabModalOpen.open}
          className={styles["modal-content-collab"]}
          backdropClassName={styles["reverted-backdrop"]}
        >
          <ModalHeader
            toggle={() => toggleCollabModal(collabModalOpen.item)}
            className={styles["modal-header"]}
            style={{
              textAlign: "center",
              margin: "40px auto -60px auto",
            }}
          >
            <span className="ema__modal_title">メッセージ</span>
            <p>{""}</p>
            <p style={{ fontSize: "0.88rem" }}>
              「連携構築」に向けて、あなたの連携ニーズ等を入力しましょう。
            </p>
          </ModalHeader>
          <ModalBody
            style={{
              padding: "80px 40px 40px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Form>
              <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                <Label for="entityType" className="mr-sm-2">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <span>連携ニーズ</span>
                    <span
                      style={{
                        padding: "2px 8px",
                        backgroundColor: "#f7caca",
                        fontSize: "9px",
                        color: "#c92d2d",
                        borderRadius: "12px",
                        border: "1px solid #c92d2d",
                      }}
                    >
                      必須
                    </span>
                  </div>
                </Label>
                <Multiselect
                  dataKey="id"
                  textField="color"
                  data={doropdownData}
                  placeholder="連携ニーズ   "
                  // defaultValue={country.edges.map((ary) => ary.node.nameJp)}
                  // defaultValue={CountryDefaultVal}
                  onChange={(e) => {
                    setCollaborationNeed(e.map((ary2) => ary2.id));
                    setCollaborationNeedName(e.map((ary2) => ary2.color));
                  }}
                />
              </FormGroup>
              <div style={{ height: "18px" }} />
              <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                <Label for="idealStartingTime" className="mr-sm-2">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <span>連携を開始したい時期</span>
                    <span
                      style={{
                        padding: "2px 8px",
                        backgroundColor: "#f7caca",
                        fontSize: "9px",
                        color: "#c92d2d",
                        borderRadius: "12px",
                        border: "1px solid #c92d2d",
                      }}
                    >
                      必須
                    </span>
                  </div>
                </Label>
                <Input
                  type="select"
                  name="idealStartingTime"
                  id="idealStartingTime"
                  onChange={(e) => setIdealStartingTime(e.target.value)}
                  placeholder="例) 半年以内に連携希望"
                >
                  {idealStartingTimeOptions.map((option) => {
                    return (
                      <option
                        selected={
                          option.value === idealStartingTime ? true : false
                        }
                        key={option.value}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    );
                  })}
                </Input>
              </FormGroup>
              <FormGroup className="mt-3 mb-1 mr-sm-2 mb-sm-0">
                <Label for="collaborationScale" className="mr-sm-2">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <span>連携規模(金額)</span>
                    <span
                      style={{
                        padding: "2px 8px",
                        backgroundColor: "#f7caca",
                        fontSize: "9px",
                        color: "#c92d2d",
                        borderRadius: "12px",
                        border: "1px solid #c92d2d",
                      }}
                    >
                      必須
                    </span>
                  </div>
                </Label>
                <Input
                  type="select"
                  name="collaborationScale"
                  id="collaborationScale"
                  onChange={(e) => setCollaborationScale(e.target.value)}
                  placeholder="例) 300~500万円の予算で検討したい"
                >
                  {collaborationScaleOptions.map((option) => {
                    return (
                      <option
                        selected={
                          option.value === collaborationScale ? true : false
                        }
                        key={option.value}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    );
                  })}
                </Input>
              </FormGroup>
              <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                <Label for="message" className="mr-sm-2">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <span>メッセージ</span>
                    <span
                      style={{
                        padding: "2px 8px",
                        backgroundColor: "#f7caca",
                        fontSize: "9px",
                        color: "#c92d2d",
                        borderRadius: "12px",
                        border: "1px solid #c92d2d",
                      }}
                    >
                      必須
                    </span>
                  </div>
                </Label>
                <Input
                  type="textarea"
                  name="message"
                  id="message"
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="連携内容、連携規模感(金銭以外）、特別な条件、その他メッセージがあればご記入ください。"
                />
              </FormGroup>
            </Form>
            <Button
              className="ema__btn__main__lg btn btn-secondary"
              style={{ marginLeft: "auto", marginTop: "16px" }}
              onClick={() => {
                setCollabModalOpen((prev) => {
                  return {
                    ...prev,
                    open: false,
                  };
                });
                toggleReviewDataModal();
              }}
              disabled={
                collaborationNeed?.length === 0 ||
                collaborationNeedName?.length === 0 ||
                !idealStartingTime ||
                !collaborationScale ||
                !message
              }
            >
              次へ
            </Button>
          </ModalBody>
          {/* <ModalFooter>
            
          </ModalFooter> */}
        </Modal>
      </div>
      <div className={styles["collab-modal-review"]}>
        <Modal
          isOpen={reviewDataModal}
          className={styles["modal-content-collab"]}
          backdropClassName={styles["reverted-backdrop"]}
        >
          <ModalHeader
            toggle={toggleReviewDataModal}
            className={styles["modal-header"]}
          >
            <span style={{ position: "absolute", left: "45%", top: "40px" }}>
              メッセージ
            </span>
          </ModalHeader>
          <ModalBody
            style={{
              padding: "80px 40px 40px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Form>
              <FormGroup>
                <Label>連携ニーズ</Label>
                <ul>
                  {collaborationNeedName.map((item) => (
                    <li>{item}</li>
                  ))}
                </ul>
              </FormGroup>
              <FormGroup>
                <Label>連携を開始したい時期</Label>
                <Input value={idealStartingTime} disabled />
              </FormGroup>
              <FormGroup>
                <Label>連携規模(金額)</Label>
                <Input value={collaborationScale} disabled />
              </FormGroup>
              <FormGroup>
                <Label>メッセージ</Label>
                <Input type="textarea" value={message} disabled />
              </FormGroup>
            </Form>
            <Button
              className="ema__btn__main__lg btn btn-secondary"
              style={{ marginLeft: "auto", marginTop: "16px" }}
              onClick={handleSubmit}
            >
              {loadingCreateCollaboration ? (
                <div>
                  <Spinner size="sm" color="light" />
                </div>
              ) : (
                "次へ"
              )}
            </Button>
          </ModalBody>
          {/* <ModalFooter>
            <Button color="primary" onClick={handleSubmit}>
              Next
            </Button>
          </ModalFooter> */}
        </Modal>
      </div>

      <div className={styles["collab-modal-review"]}>
        <Modal
          toggle={() => setRecommendationModal(false)}
          isOpen={recommendationModal}
          className={styles["modal-content-collab"]}
          backdropClassName={styles["reverted-backdrop"]}
        >
          <ModalHeader
            toggle={() => setRecommendationModal(false)}
            className={styles["modal-header"]}
          ></ModalHeader>
          <ModalBody>
            <div
              style={{
                color: "red",
                marginBottom: "10px",
                textAlign: "center",
                padding: "60px 50px 35px",
              }}
            >
              <div
                style={{
                  marginBottom: "24px",
                  position: "absolute",
                  top: "10px",
                  left: "45%",
                  color: "black",
                }}
              >
                送信完了
              </div>

              <div
                style={{
                  marginBottom: "55px",
                }}
              >
                CSOがプロフィールを確認するため、
                <br />
                情報をアップデートしましょう。
              </div>
              <Link
                style={{
                  padding: "9px 25px",
                  backgroundColor: "#44CAE1",
                  border: "none",
                  color: "white",
                  borderRadius: "5px",
                }}
                to="/dashboards/plofile-organization/"
              >
                {"情報をアップデートする"}
              </Link>
            </div>
          </ModalBody>
        </Modal>
      </div>
      <div className={styles["delete-modal-container"]}>
        <Modal
          isOpen={deleteModalOpen}
          toggle={toggle}
          backdropClassName={styles["reverted-backdrop"]}
          className={styles["modal-content"]}
        >
          <ModalHeader
            toggle={toggle}
            className={styles["modal-header"]}
          ></ModalHeader>
          <ModalBody
            style={{
              padding: "16px 40px 40px 40px",
            }}
          >
            <div
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              {`${selectedOrg?.cso?.name} を`}
              <br />
              <div>CSO連携リストから 削除しますか</div>
            </div>
            <Button
              style={{
                width: "100%",
                backgroundColor: "#EB5757",
                border: "none",
                marginTop: "32px",
                padding: "13px 53px",
              }}
              onClick={handleDeleteCsoWish}
            >
              削除
            </Button>
          </ModalBody>
        </Modal>
      </div>
    </Fragment>
  );
};

export default CSOPartnershipTable;
